// extracted by mini-css-extract-plugin
export default {"div":"WeatherHourlyForecast_div__8YBp6","title":"WeatherHourlyForecast_title__yIwY8"};